export interface PanelVerificationUser {
  email_verified?: boolean;
  email_verified_at?: string | null;
  phone_verified?: boolean;
  email_panel_verification_required?: boolean;
  phone_panel_verification_required?: boolean;
}

/** Where an unverified user must stay when an admin has closed the panel. */
export function panelVerificationPath(user: PanelVerificationUser | null | undefined): '/verify-email' | '/verify-phone' | null {
  if (!user) return null;
  const emailVerified = !!(user.email_verified || user.email_verified_at);
  if (user.email_panel_verification_required && !emailVerified) return '/verify-email';
  if (user.phone_panel_verification_required && !user.phone_verified) return '/verify-phone';
  return null;
}
